/**
 * Partners Feed shared block scripts
 */
import { partnersFeedPager } from './scripts/partners-feed-pager'
import { partnersFeedFilter } from './scripts/partners-feed-filter'
import { partnersFeedAccordion } from './scripts/partners-feed-accordion'
import { partnersFeedHasPolyfill } from './scripts/partners-feed-has-polyfill'
import { partnersFeedInitialize } from './scripts/partners-feed-initialize'

document.addEventListener(
	'facetwp-loaded',
	() => {
		// get global facetwp script and the feed's containing element
		const { FWP } = window
		const feeds = document.querySelectorAll('.partners-feed')
		// bail if we don't have all we need
		if (!FWP || !feeds.length) return
		// get the partners feed (should only be one per page...)
		feeds.forEach((elWrap) => {
			const feed = {
				// faceetwp's object
				FWP,
				// the feed wrapper/container
				elWrap,
				// the partner type categories control wrapper
				elCats: elWrap.querySelector('.partners-feed__control--category'),
				// the partner type category labels (they contain radio button inputs)
				elLabels: elWrap.querySelectorAll('.partners-feed__control--category label'),
				// the main posts feed list container
				elPosts: elWrap.querySelector('.partners-feed__posts'),
			}
			// bind controls for partner type categories
			partnersFeedFilter(feed)
			// add features to facetwp's pagination
			partnersFeedPager(feed)
			// add accordions for mobile control titles
			partnersFeedAccordion(feed)
			// handle :has() logic for firefox (remove this once it's widely supported)
			partnersFeedHasPolyfill(feed)
			// initialize the feed
			partnersFeedInitialize(feed)
		})
	},
	{ passive: true, once: true }
)
